import { css } from 'emotion';
import React from 'react';
import { Modal } from 'screens/EpisodeScreen/components/Modal';
import { ErrorModal } from 'client/screens/EpisodeScreen/components/CuePoints/types';
import { useT } from 'client/i18n/hooks/useT';

export function AdInsertionErrorModal({
  dismissErrorModal,
  errorModal,
}: {
  dismissErrorModal: () => void;
  errorModal: ErrorModal;
}) {
  const t = useT();
  return (
    <Modal
      handleClose={dismissErrorModal}
      primaryButton={{
        copy: t('Button.Ok', 'Ok', 'Ok button text'),
        onClick: dismissErrorModal,
      }}
    >
      <h2
        className={css`
          font-size: 2.2rem;
          font-weight: bold;
          margin: 0 0 8px 0;
        `}
      >
        {errorModal.title}
      </h2>
      <p>{errorModal.body}</p>
    </Modal>
  );
}
